/**
 * RoomSceneImageUI - Pure UI component for displaying the room scene image.
 * Shows a placeholder until the image is loaded.
 * @param {Object} props
 * @param {string} props.imageUrl - URL of the room scene image
 * @returns {JSX.Element}
 */
import React, { useState } from "react"
import ImagePlaceHolder from "@/components/core/Image/ImagePlaceHolder"
import useWindowResize from "@/hooks/useWindowResize"
import { getPresetUrl } from "@/utils/index"

const RoomSceneImageUI = ({
  imageUrl = "",
  presetConfig = "",
  swatchUrl = "",
}) => {
  const [loaded, setLoaded] = useState(false)
  const [width] = useWindowResize()
  const parts = imageUrl ? imageUrl.split("/") : []
  const imageAssetID = parts.length > 0 ? parts[parts.length - 1] : ""
  const containerClass = `shop-the-room-inspiration__left-side${
    !loaded ? " shop-the-room-inspiration__left-side--loading" : ""
  }`
  return (
    <div className={containerClass}>
      {!loaded && <ImagePlaceHolder assetID="room-scene" />}
      <img
        alt="Room scene"
        src={getPresetUrl(width, 0, swatchUrl, imageAssetID, presetConfig)}
        hidden={!loaded}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
    </div>
  )
}

export default RoomSceneImageUI
